import { z } from 'zod';
export const orderEmailPreferenceKeys = [
    'statusSubmitted',
    'statusOnHold',
    'statusInAssembly',
    'statusAssembled',
    'statusReadyForShipment',
    'statusDelivered',
    'statusClosed',
    'statusCancelled',
    'deliveryUpdated',
    'workCompletionUpdated',
    'documentAttached',
    'deliveryStatusChanged',
    'commentAdded',
];
export const orderEmailPreferencesSchema = z
    .object({
    statusSubmitted: z.boolean(),
    statusOnHold: z.boolean(),
    statusInAssembly: z.boolean(),
    statusAssembled: z.boolean(),
    statusReadyForShipment: z.boolean(),
    statusDelivered: z.boolean(),
    statusClosed: z.boolean(),
    statusCancelled: z.boolean(),
    deliveryUpdated: z.boolean(),
    workCompletionUpdated: z.boolean(),
    documentAttached: z.boolean(),
    deliveryStatusChanged: z.boolean(),
    commentAdded: z.boolean().default(true),
})
    .strict();
export const defaultOrderEmailPreferences = {
    statusSubmitted: true,
    statusOnHold: true,
    statusInAssembly: true,
    statusAssembled: true,
    statusReadyForShipment: true,
    statusDelivered: true,
    statusClosed: true,
    statusCancelled: true,
    deliveryUpdated: true,
    workCompletionUpdated: true,
    documentAttached: true,
    deliveryStatusChanged: true,
    commentAdded: true,
};
//# sourceMappingURL=notification.js.map